import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import Checkbox from 'lib/control/Checkbox'
import Error from 'lib/struct/Error'

import ShopPromoLabel from './ShopPromoLabel'
import Field from '../../struct/Field'
import Hint from '../../struct/Hint'
import DependentCheckbox from '../../control/DependentCheckbox'
import InputText from '../../control/DependentInputText'
import InputTextarea from '../../control/DependentInputTextarea'

import styles from './ProfileCouponsSettings.less'

@observer export default class ProfileCouponsSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        if (context.coupons.length === 0) {
            return (
                <Field label="Промокоды" fieldClass={styles['block--empty']}>
                    Промоакции с промокодами не найдены.
                </Field>
            )
        }

        return (
            <Field label="Промокоды" fieldClass={styles['block']}>
                {
                    context.coupons.map(shop_coupon => (
                        <div key={shop_coupon.id} className={styles['coupon-settings-block']}>
                            <CouponSettings
                                context={context}
                                shop_coupon={shop_coupon}
                            />
                        </div>
                    ))
                }
            </Field>
        )
    }
}

@observer
class CouponSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const form_state = context.form_state
        const profile = context.profile

        /** @type {ShopCoupon} */
        const shop_coupon = this.props.shop_coupon

        if (shop_coupon.error) {
            return (
                <Checkbox
                    checked={false}
                    disabled={true}
                >
                    <ShopPromoLabel
                        label={shop_coupon.code}
                        promo={shop_coupon}
                    />

                    <Hint className={styles['coupon-hint']}>{shop_coupon.hint}</Hint>

                    <Error error={shop_coupon.error}/>
                </Checkbox>
            )
        }

        return (
            <Fragment>
                <DependentCheckbox
                    checked={profile.isMarketCouponEnabled(shop_coupon)}
                    onChange={e => profile.toggleMarketCoupon(shop_coupon, e.target.checked)}
                    state={form_state}
                >
                    <ShopPromoLabel
                        label={shop_coupon.code}
                        promo={shop_coupon}
                    />

                    <Hint className={styles['coupon-hint']}>{shop_coupon.hint}</Hint>
                </DependentCheckbox>

                {
                    profile.isMarketCouponEnabled(shop_coupon) ? (
                        <div className={styles['coupon-extra-settings-block']}>
                            <Field label="Краткое описание">
                                <InputTextarea
                                    value={profile.getMarketCouponConfig(shop_coupon).description}
                                    onChange={e => profile.getMarketCouponConfig(shop_coupon).description = e.target.value}
                                    state={form_state}
                                />
                            </Field>

                            <Field label="Ссылка на описание">
                                <InputText
                                    value={profile.getMarketCouponConfig(shop_coupon).url}
                                    onChange={e => profile.getMarketCouponConfig(shop_coupon).url = e.target.value}
                                    state={form_state}
                                />
                            </Field>
                        </div>
                    ) : (null)
                }
            </Fragment>
        )
    }
}